module.exports = __webpack_public_path__ + "static/media/bg-section-footer.552339bd.png";